import type React from 'react';
import { Box, Inline } from 'braid-design-system';
import {
  trackEmailClickEvent,
  trackPhoneClickEvent,
  trackEmailCopyClickEvent,
  trackPhoneCopyClickEvent,
} from '../../../utils/events';
import { ContactInfo } from './ContactInfo';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

interface Props {
  email: string;
  phone?: string;
  candidateId: string;
}

export const ContactLinks: React.FC<Props> = ({
  email = '',
  phone,
  candidateId,
}) => {
  const onEmailClick = () => {
    trackEmailClickEvent({ candidateId });
  };

  const onPhoneClick = () => {
    trackPhoneClickEvent({ candidateId });
  };

  const onCopyEmailClick = () => {
    trackEmailCopyClickEvent({ candidateId });
  };
  const onCopyPhoneClick = () => {
    trackPhoneCopyClickEvent({ candidateId });
  };
  const { t } = useTranslations(translations);

  return (
    <Box display="flex" onMouseDown={(e) => e.stopPropagation()}>
      <Inline space="small" collapseBelow="tablet">
        <ContactInfo
          label={t('Email candidateEmail', { candidateEmail: email })}
          copyButton={{
            id: 'detailsViewContactLinksEmailCopy',
            label: t('Copy email'),
          }}
          contactValue={email}
          href={`mailto:${email}`}
          onContactClick={onEmailClick}
          onCopyClick={onCopyEmailClick}
        />

        {phone !== undefined && phone !== '' && (
          <>
            <ContactInfo
              label={t('Call candidatePhoneNum', { candidatePhoneNum: phone })}
              copyButton={{
                id: 'detailsViewContactLinksPhoneCopy',
                label: t('Copy phone number'),
              }}
              contactValue={phone}
              href={`tel:${phone}`}
              onContactClick={onPhoneClick}
              onCopyClick={onCopyPhoneClick}
            />
          </>
        )}
      </Inline>
    </Box>
  );
};
